import styles from './FooterArtwork.module.scss';
import { type FooterImage } from '../../types';

interface FooterArtworkProps {
  artwork?: FooterImage | null;
  className?: string;
}

export function FooterArtwork({ artwork, className }: FooterArtworkProps) {
  if (!artwork || !artwork.url) {
    return null;
  }

  return (
    <div className={className}>
      <img
        src={artwork.url}
        className={styles.artworkImage}
        alt={artwork.alt || ''}
        loading="lazy"
      />
    </div>
  );
}
